import application from 'application/application';

import template from './publications.template.html';

import controller from './publications.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.publications', {
				// url: '/publicacoes?paginaAtual&palavraChave&lido&registrosPorPagina&diary&note&dataInicio&dataFim',
				url: '/?paginaAtual&palavraChave&lido&registrosPorPagina&diary&note&dataInicio&dataFim',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller: controller
					}
				},
				data: {
					documentTitle: 'Publicações',
					displayName: 'Publicações'
				}
			});

	}]);
